import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initialState } from '@features/ConsentAndPermission/NehrAccessRestriction/store/initialState';
import type { NehrARInstitution } from '@features/ConsentAndPermission/NehrAccessRestriction/types';

const nehrAccessRestrictionSlice = createSlice({
  name: 'NehrAccessRestriction',
  initialState,
  reducers: {
    setShareAccessWith: (state, action: PayloadAction<NehrARInstitution[]>) => {
      state.shareAccessWith = action.payload;
    },
    setRemoveAccessFrom: (state, action: PayloadAction<NehrARInstitution[]>) => {
      state.removeAccessFrom = action.payload;
    },
    setVideoWatched: (state, action: PayloadAction<boolean>) => {
      state.videoWatched = action.payload;
    },
    setDeclarationAcknowledged: (state, action: PayloadAction<boolean>) => {
      state.declarationAcknowledged = action.payload;
    },
    resetAll: (state) => {
      state.shareAccessWith = initialState.shareAccessWith;
      state.removeAccessFrom = initialState.removeAccessFrom;
      state.videoWatched = initialState.videoWatched;
      state.declarationAcknowledged = initialState.declarationAcknowledged;
    },
  },
});

export const { actions: nehrAccessRestrictionAction } = nehrAccessRestrictionSlice;
export default nehrAccessRestrictionSlice.reducer;
